import {ClsConfig} from '../../../util/cls-config';
import {ClsObjGenerico} from '../../util/cls-obj-generico';
import {ClsUtil} from '../../../util/cls-util';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {EnumMaxLengthFields} from '../../../core/models/enum/enum-longitud-maxima-columnas';
import {EnumTiposDatosPegado} from '../../../core/models/enum/enum-tipos-datos-pegado';
import {ClsColDetallePegado, ClsPegado, GridColumns} from 'src/app/core/models/cls-pegado';
import {inject} from "@angular/core";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";

export class ClsObjPegado extends ClsConfig {
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  public dataDetallePegado: ClsColDetallePegado[] = []; // Codigo: string; Columna: string; Detalle: string;
  private tipoMsg = inject(TipoMensajesService);
  constructor() {
    super();
  }
  public verificarDetallePegado(data: any, headers: string[], colsRequeridas: string[], grid: EnumNombresGrids, objGenerico?: any) {
    this.dataDetallePegado = [];
    let duplicateElements = [];
    if (grid !== EnumNombresGrids.Conceptos && grid !== EnumNombresGrids.Matrices) {
      duplicateElements = ClsUtil.findDuplicates(data, headers[0]);
    }
    if (duplicateElements.length > 0) {
      duplicateElements.forEach(x => this.dataDetallePegado.push({Codigo: x, Columna: headers[0], Detalle: objGenerico.getTranslationsSubject('MENSAJES.ALERT.REGISTRO_DUPLICADO').replace('{0}', x)}));
    }
    data.forEach(x => {
      const valores: ClsPegado[] = this.crearObjToValidate(x, headers, grid);
      const codigo = valores[0].Value;
      valores.forEach( item => {
        if (colsRequeridas.some(colRequired => colRequired === item.Column)) {
          const errorNulo = this.validarNulo(codigo, item);
          if (ClsUtil.esNulo(errorNulo)) { // No hay error de nulo, por lo tanto validamos...
            this.validarCampos(codigo, item, grid);
          }
        } else {
          if (!ClsUtil.esNulo(item.Value)) {
            this.validarCampos(codigo, item, grid);
          }
        }
      });
    });
    return this.dataDetallePegado; // quitar esta linea
  }

  public verificarDetallePegadoEspecial(data: any, headers: string[], colsRequeridasPartidas: string[], colsRequeridasConceptos: string[], grid: any, separator: string) {
    this.dataDetallePegado = [];
    const campoPartida = this.mObjGenerico.getTranslationsSubject('GRIDS.PARTIDAS.COL_PARTIDA');
    const campoCodigo = this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CODIGO');
    const partidasNull = data.filter(x => x[campoPartida] === ''); // filtramos las partidas que vienen vacias
    if (partidasNull.length > 0) {
      partidasNull.forEach(x => this.dataDetallePegado.push({Codigo: x[campoCodigo], Columna: headers[0], Detalle: this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', headers[0])}));
    }
    data.forEach(x => {
      const valores: ClsPegado[] = this.crearObjToValidate(x, headers, grid, separator);
      valores.forEach(item => {
        if (!ClsUtil.esNulo(x[campoCodigo])) { // EsConcepto
          // validar requeridos (Codigo, Cantidad)
          // validar MaxLength
          // validar cantidades (Costos, Precios, Cantidad)
          // validar Tipo Insumo
          const esRequerido = colsRequeridasConceptos.find(z => z === item.Column);
          if (!ClsUtil.esNulo(esRequerido)) { // valida las cols requeridas
            const errorNulo = this.validarNulo(valores[5].Value, item);
            if (ClsUtil.esNulo(errorNulo)) { // No hay error de nulo, por lo tanto validamos maxlength y cantidad que es requerida
              this.validarCampos(valores[5].Value, item, grid);
              this.validarMaxLength(valores[5].Value, item);
            }
          } else { // valida las cols no requeridas
            if (!ClsUtil.esNulo(item.Value)) {
              this.validarCampos(valores[5].Value, item, grid);
              this.validarMaxLength(valores[5].Value, item);
              // validar Tipo Insumo
              if (item.Column === this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_TIPO')) {
                this.validarTipoInsumoToNumber(valores[5].Value, item);
              }
            }
          }
        } else { // EsPartida
          // validar requeridos (Partida)
          // validar MaxLength
          // validar cantidades (M2)
          const esRequerido = colsRequeridasPartidas.find(z => z === item.Column);
          if (!ClsUtil.esNulo(esRequerido)) { // valida las cols requeridas
            const errorNulo = this.validarNulo(valores[0].Value, item);
            if (ClsUtil.esNulo(errorNulo)) { // No hay error de nulo, por lo tanto validamos maxlength
              this.validarMaxLength(valores[0].Value, item);
            }
          } else { // valida las cols no requeridas
            if (!ClsUtil.esNulo(item.Value)) {
              // validar MaxLength
              this.validarMaxLength(valores[0].Value, item);
              // validar cantidades (M2)
              this.validarCampos(valores[0].Value, item, grid);
            }
          }
        }
      });
    });
  }

  // region Crear Objs
  public crearObjToValidate(data: any, headers: string[], grid: any, separator?: string): ClsPegado[] {
    let objValid: ClsPegado[] = [];
    switch (grid) {
      case EnumNombresGrids.Empresas:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_EMPRESA'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_RS'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.RazonSocial, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_CIUDAD'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_DIRECCION'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.Direccion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_COLONIA'), Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Colonia, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_RESPONSABLE'), Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_TELEFONO'), Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Telefono, DataType: EnumTiposDatosPegado.String},
          {Column: 'RFC', Value: data[headers[7]], MaxValue: EnumMaxLengthFields.RFC, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_CP'), Value: data[headers[8]], MaxValue: EnumMaxLengthFields.CP, DataType: EnumTiposDatosPegado.String},
          {Column: 'CMIC', Value: data[headers[9]], MaxValue: EnumMaxLengthFields.CMIC, DataType: EnumTiposDatosPegado.String},
          {Column: 'Fax', Value: data[headers[10]], MaxValue: EnumMaxLengthFields.Fax, DataType: EnumTiposDatosPegado.String},
          {Column: 'IMSS', Value: data[headers[11]], MaxValue: EnumMaxLengthFields.IMSS, DataType: EnumTiposDatosPegado.String},
          {Column: 'Infonavit', Value: data[headers[12]], MaxValue: EnumMaxLengthFields.Infonavit, DataType: EnumTiposDatosPegado.String},
          {Column: 'Mail', Value: data[headers[13]], MaxValue: EnumMaxLengthFields.Mail, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_SITIO_WEB'), Value: data[headers[14]], MaxValue: EnumMaxLengthFields.Url, DataType: EnumTiposDatosPegado.Url}];
        break;
      case EnumNombresGrids.Ciudades:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CIUDAD.COL_CIUDAD'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CIUDAD.COL_DESCRIPCION'), Value: ClsUtil.toSubstring(data[headers[1]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CIUDAD.COL_ESTADO'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.CodigoEstado, DataType: EnumTiposDatosPegado.String}];
        break;
      case EnumNombresGrids.TiposLicitaciones:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_LICITACION.COL_TIPO'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_LICITACION.COL_DESCRIPCION'), Value: ClsUtil.toSubstring(data[headers[1]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String}];
        break;
      case EnumNombresGrids.Vendedores:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_VENDEDOR'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_NOMBRE'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.NombreCliente, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_CARGO'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.Cargo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_TELEFONO'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.Telefono, DataType: EnumTiposDatosPegado.String},
          {Column: 'Mail', Value: data[headers[1]], MaxValue: EnumMaxLengthFields.Mail, DataType: EnumTiposDatosPegado.Mail}];
        break;
      case EnumNombresGrids.Clientes:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_CLIENTE'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_NOMBRE'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.NombreCliente, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_DIRECCION'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.Direccion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_COLONIA'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.Colonia, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_CIUDAD'), Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_CP'), Value: data[headers[5]], MaxValue: EnumMaxLengthFields.CP, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_TELEFONO'), Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Telefono, DataType: EnumTiposDatosPegado.String},
          {Column: 'Mail', Value: data[headers[7]], MaxValue: EnumMaxLengthFields.Mail, DataType: EnumTiposDatosPegado.Mail}];
        break;
      case EnumNombresGrids.Proveedores:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_PROVEEDOR'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_CIUDAD'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_RS'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.RazonSocial, DataType: EnumTiposDatosPegado.String},
          {Column: 'RFC', Value: data[headers[3]], MaxValue: EnumMaxLengthFields.RFC, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_DIRECCION'), Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Direccion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_COLONIA'), Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Colonia, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_CP'), Value: data[headers[6]], MaxValue: EnumMaxLengthFields.CP, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_TELEFONO'), Value: data[headers[7]], MaxValue: EnumMaxLengthFields.Telefono, DataType: EnumTiposDatosPegado.String},
          {Column: 'Fax', Value: data[headers[8]], MaxValue: EnumMaxLengthFields.Fax, DataType: EnumTiposDatosPegado.String},
          {Column: 'Mail', Value: data[headers[9]], MaxValue: EnumMaxLengthFields.Mail, DataType: EnumTiposDatosPegado.Mail},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_CONTACTO'), Value: data[headers[10]], MaxValue: EnumMaxLengthFields.Contacto, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_OBS'), Value: data[headers[11]], MaxValue: EnumMaxLengthFields.Observacion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_CELULAR'), Value: data[headers[12]], MaxValue: EnumMaxLengthFields.Celular, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_PAGINA'), Value: data[headers[13]], MaxValue: EnumMaxLengthFields.Pagina, DataType: EnumTiposDatosPegado.Url},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_PROV_DEFAULT'), Value: data[headers[14]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean}
        ];
        break;
      case EnumNombresGrids.Responsables:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_RESPONSABLE'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_NOMBRE'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.NombreResponsable, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_CARGO'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.Cargo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_TELEFONO'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.Telefono, DataType: EnumTiposDatosPegado.String},
          {Column: 'Mail', Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Mail, DataType: EnumTiposDatosPegado.Mail}];
        break;
      case EnumNombresGrids.Estados:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.ESTADO.COL_ESTADO'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.CodigoEstado, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.ESTADO.COL_NOMBRE'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.NombreEstado, DataType: EnumTiposDatosPegado.String}];
        break;
      case EnumNombresGrids.Familias:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.FAMILIA.COL_FAMILIA'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.FAMILIA.COL_DESCRIPCION'), Value: ClsUtil.toSubstring(data[headers[1]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String}];
        break;
      case EnumNombresGrids.Unidades:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.UNIDAD.COL_UNIDAD'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.UNIDAD.COL_DESCRIPCION'), Value: ClsUtil.toSubstring(data[headers[1]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String}];
        break;
      case EnumNombresGrids.TipoInsumos:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_TIPO'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.Number},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_DESCRIPCION'), Value: ClsUtil.toSubstring(data[headers[1]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String}];
        break;
      case EnumNombresGrids.Regiones:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.REGION.COL_REGION'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.REGION.COL_DESCRIPCION'), Value: ClsUtil.toSubstring(data[headers[1]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String}];
        break;
      case EnumNombresGrids.Conceptos:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CODIGO'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_RENGLON'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.Renglon, DataType: EnumTiposDatosPegado.Number},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_MARCA'), Value: data[headers[2]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CODIGO_AUX'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.CodigoAux, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION_LARGA'), Value: data[headers[4]], MaxValue: EnumMaxLengthFields.DescripcionLarga, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION'), Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_UNIDAD'), Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CANTIDAD'), Value: data[headers[7]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_COSTO_M1'), Value: data[headers[8]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_PRECIO_M1'), Value: data[headers[9]], MaxValue: EnumMaxLengthFields.Precio, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_COSTO_M2'), Value: data[headers[10]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_PRECIO_M2'), Value: data[headers[11]], MaxValue: EnumMaxLengthFields.Precio, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_TIPO_INSUMO'), Value: data[headers[12]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.Number},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_TIPO_%'), Value: data[headers[13]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.Number},
          {Column: 'C.H.', Value: data[headers[14]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean}
        ];
        break;
      case EnumNombresGrids.ExpIns:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_CODIGO'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_MARCA'), Value: data[headers[1]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_DESCRIPCION'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.DescripcionLarga, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_UNIDAD'), Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_TIPO_INSUMO'), Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.Number},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_COSTO_M1'), Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_COSTO_M2'), Value: data[headers[7]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_FAMILIA'), Value: data[headers[8]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_PROVEEDOR'), Value: data[headers[9]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_INS_INT'), Value: data[headers[10]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_FECHA_M1'), Value: data[headers[11]], MaxValue: EnumMaxLengthFields.Fecha, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_FECHA_M2'), Value: data[headers[12]], MaxValue: EnumMaxLengthFields.Fecha, DataType: EnumTiposDatosPegado.String},
          {Column: 'C.H.', Value: data[headers[13]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_ES_PORCENTAJE'), Value: data[headers[14]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_TIPO_%'), Value: data[headers[15]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.Number},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_REFERENCIA'), Value: data[headers[16]], MaxValue: EnumMaxLengthFields.Referencia, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_CONTENDIO'), Value: data[headers[17]], MaxValue: EnumMaxLengthFields.Url, DataType: EnumTiposDatosPegado.Url}];
        break;
      case EnumNombresGrids.Partidas:
        const columnas = this.crearColumnasPegadoEspecial();
        objValid = [{Column: columnas[0], Value: this.getPartida(data[headers[0]], separator), MaxValue: EnumMaxLengthFields.Codigo, DataType: String},
          {Column: columnas[1], Value: data[headers[1]], MaxValue: EnumMaxLengthFields.Codigo, DataType: String},
          {Column: columnas[2], Value: data[headers[2]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: String},
          {Column: columnas[3], Value: data[headers[3]], MaxValue: 1, DataType: Boolean},
          {Column: columnas[4], Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: String},
          {Column: columnas[5], Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Codigo, DataType: String},
          {Column: columnas[6], Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Codigo, DataType: String},
          {Column: columnas[7], Value: data[headers[7]], MaxValue: EnumMaxLengthFields.DescripcionLarga, DataType: String},
          {Column: columnas[8], Value: data[headers[8]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: String},
          {Column: columnas[9], Value: data[headers[9]], MaxValue: EnumMaxLengthFields.Codigo, DataType: String},
          {Column: columnas[10], Value: data[headers[10]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: String},
          {Column: columnas[11], Value: data[headers[11]], MaxValue: EnumMaxLengthFields.Costo, DataType: String},
          {Column: columnas[12], Value: data[headers[12]], MaxValue: EnumMaxLengthFields.Precio, DataType: String},
          {Column: columnas[13], Value: data[headers[13]], MaxValue: EnumMaxLengthFields.Costo, DataType: String},
          {Column: columnas[14], Value: data[headers[14]], MaxValue: EnumMaxLengthFields.Precio, DataType: String},
          {Column: columnas[15], Value: data[headers[15]], MaxValue: EnumMaxLengthFields.Codigo, DataType: String}];
        break;
      case EnumNombresGrids.Matrices:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_CODIGO'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_RENGLON'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_DESCRIPCION'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_DESCRIPCION_LARGA'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.DescripcionLarga, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_TIPO'), Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Codigo, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_UNIDAD'), Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Codigo, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_COSTO_M1'), Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Costo, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_COSTO_M2'), Value: data[headers[7]], MaxValue: EnumMaxLengthFields.Costo, DataType: String},
          {Column: '/', Value: data[headers[8]], MaxValue: 1, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_CANT'), Value: data[headers[9]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_EXPRESION'), Value: data[headers[10]], MaxValue: EnumMaxLengthFields.Expresion, DataType: String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_ES_PORCENTAJE'), Value: data[headers[11]], MaxValue: 1, DataType: String}];
        break;
      case EnumNombresGrids.Materiales:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_CODIGO'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_ES_PORCENTAJE'), Value: data[headers[1]] === 1, MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_DESCRIPCION'), Value: ClsUtil.toSubstring(data[headers[2]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_DESCRIPCION_LARGA'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.DescripcionLarga, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_TIPO_INSUMO'), Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.Number},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_UNIDAD'), Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_COSTO_LAB_M'), Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_FLETES_M'), Value: data[headers[7]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_MANIOBRA_M'), Value: data[headers[8]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_ALMACENAJE_M'), Value: data[headers[9]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_DERECHOS_M'), Value: data[headers[10]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_MERMAS_M'), Value: data[headers[11]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_COSTO_M'), Value: data[headers[12]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_FECHA_M'), Value: data[headers[13]], MaxValue: EnumMaxLengthFields.Fecha, DataType: EnumTiposDatosPegado.String}];
        break;
      case EnumNombresGrids.MO:
        objValid = [{Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_CODIGO'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_DESCRIPCION'), Value: ClsUtil.toSubstring(data[headers[1]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_DESCRIPCION_LARGA'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.DescripcionLarga, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_TIPO_INSUMO'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.Number},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_UNIDAD'), Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_SALARIO_BASE_M'), Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_FACTOR_SALARIO_INTEGRADO_M'), Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Quantity},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_FASAR'), Value: data[headers[7]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Quantity},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_SALARIO_INTEGRADO_M'), Value: data[headers[8]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_SALARIO_REAL_M'), Value: data[headers[9]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_VIATICOS_M'), Value: data[headers[10]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_ALIMENTACION_HOSPEDAJE_M'), Value: data[headers[11]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_GASTOS_SEPELIO_M'), Value: data[headers[12]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_OTRAS_PRESTACIONES_M'), Value: data[headers[13]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_COSTO_TOTAL_M'), Value: data[headers[14]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.MO.COL_TIPO_FASAR'), Value: data[headers[15]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.Number}];
        break;
      case EnumNombresGrids.Maquinaria:
        const colsEQ = this.colsEQClass.map(key =>
          this.mObjGenerico.getTranslationsSubject(key.Header)
        );
        objValid = [{Column: colsEQ[0], Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[1], Value: ClsUtil.toSubstring(data[headers[1]], EnumMaxLengthFields.Descripcion), MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[2], Value: data[headers[2]], MaxValue: EnumMaxLengthFields.DescripcionLarga, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[3], Value: data[headers[3]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[4], Value: data[headers[4]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},

          {Column: colsEQ[5], Value: data[headers[5]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},
          {Column: colsEQ[6], Value: data[headers[6]], MaxValue: EnumMaxLengthFields.Costo, DataType: EnumTiposDatosPegado.Currency},

          {Column: colsEQ[7], Value: data[headers[7]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[8], Value: data[headers[8]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[9], Value: data[headers[9]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[10], Value: data[headers[10]], MaxValue: EnumMaxLengthFields.CHs, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[11], Value: data[headers[11]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[12], Value: data[headers[12]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[13], Value: data[headers[13]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[14], Value: data[headers[14]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[15], Value: data[headers[15]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[16], Value: data[headers[16]], MaxValue: EnumMaxLengthFields.Cantidad, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[17], Value: data[headers[17]], MaxValue: EnumMaxLengthFields.CHs, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[18], Value: data[headers[18]], MaxValue: EnumMaxLengthFields.CHs, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[19], Value: data[headers[19]], MaxValue: EnumMaxLengthFields.CHs, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[20], Value: data[headers[20]], MaxValue: EnumMaxLengthFields.CHs, DataType: EnumTiposDatosPegado.Quantity},
          {Column: colsEQ[21], Value: data[headers[21]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.Quantity},

          {Column: colsEQ[22], Value: data[headers[22]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[23], Value: data[headers[23]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[24], Value: data[headers[24]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[25], Value: data[headers[25]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[26], Value: data[headers[26]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[27], Value: data[headers[27]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: colsEQ[28], Value: data[headers[28]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},

          {Column: colsEQ[29], Value: data[headers[29]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
        ];
        break;
      case EnumNombresGrids.Calendario:
        objValid = [
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_FECHA'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Fecha, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_DESCRIPCION'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_TIPO'), Value: data[headers[2]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_ESTADO'), Value: data[headers[3]], MaxValue: EnumMaxLengthFields.Codigo, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_LUNES'), Value: data[headers[4]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_MARTES'), Value: data[headers[5]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_MIERCOLES'), Value: data[headers[6]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_JUEVES'), Value: data[headers[7]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_VIERNES'), Value: data[headers[8]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_SABADO'), Value: data[headers[9]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_DOMINGO'), Value: data[headers[10]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_PREDETERMINADO'), Value: data[headers[11]] === '1', MaxValue: 1, DataType: EnumTiposDatosPegado.Boolean},
        ];
        break;
      case EnumNombresGrids.Fechas:
        objValid = [
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIOS.COL_FECHA_NO_LABORABLE'), Value: data[headers[0]], MaxValue: EnumMaxLengthFields.Fecha, DataType: EnumTiposDatosPegado.String},
          {Column: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIOS.COL_DESCRIPCION'), Value: data[headers[1]], MaxValue: EnumMaxLengthFields.Descripcion, DataType: EnumTiposDatosPegado.String}
        ];
    }
    return objValid;
  }

  public colsEQClass: GridColumns[] = [];
  public setcolumns(){
    this.colsEQClass =
      [{Header: 'GRIDS.MAQUINARIA.COL_CODIGO', Required: true},
        {Header: 'GRIDS.MAQUINARIA.COL_DESCRIPCION'},
        {Header: 'GRIDS.MAQUINARIA.COL_DESCRIPCION_LARGA', Required: true},
        {Header: 'GRIDS.MAQUINARIA.COL_TIPO_INSUMO'},
        {Header: 'GRIDS.MAQUINARIA.COL_UNIDAD', Required: true},

        {Header: 'GRIDS.MAQUINARIA.COL_COSTO_M1'},
        {Header: 'GRIDS.MAQUINARIA.COL_COSTO_M2'},

        {Header: 'GRIDS.MAQUINARIA.COL_VIDA_ECONOMICA_LLANTAS'},
        {Header: 'GRIDS.MAQUINARIA.COL_VIDA_ECONOMICA_PIEZAS'},
        {Header: 'GRIDS.MAQUINARIA.COL_POTENCIA'},
        {Header: 'GRIDS.MAQUINARIA.COL_FACTOR_OPERACION'},
        {Header: 'GRIDS.MAQUINARIA.COL_FACTOR_COMBUSTIBLE'},
        {Header: 'GRIDS.MAQUINARIA.COL_FACTOR_OTRAS_FUENTES'},
        {Header: 'GRIDS.MAQUINARIA.COL_FACTOR_LUBRICANTE'},
        {Header: 'GRIDS.MAQUINARIA.COL_CAPACIDAD_CARTER'},
        {Header: 'GRIDS.MAQUINARIA.COL_VIDA_ECONOMICA_HRS'},
        {Header: 'GRIDS.MAQUINARIA.COL_HORAS_X_ANIO'},
        {Header: 'GRIDS.MAQUINARIA.COL_VALOR_RESCATE'},
        {Header: 'GRIDS.MAQUINARIA.COL_TASA_INTERES_M1'},
        {Header: 'GRIDS.MAQUINARIA.COL_TASA_INTERES_M2'},
        {Header: 'GRIDS.MAQUINARIA.COL_PRIMA_ANUAL_SEGUROS'},
        {Header: 'GRIDS.MAQUINARIA.COL_FACTOR_MANTENIMIENTO'},

        {Header: 'GRIDS.MAQUINARIA.COL_MARCA'},
        {Header: 'GRIDS.MAQUINARIA.COL_MODELO'},
        {Header: 'GRIDS.MAQUINARIA.COL_NUMERO_SERIE'},
        {Header: 'GRIDS.MAQUINARIA.COL_CAPACIDAD'},
        {Header: 'GRIDS.MAQUINARIA.COL_UBICACION'},
        {Header: 'GRIDS.MAQUINARIA.COL_VIDA_UTIL'},
        {Header: 'GRIDS.MAQUINARIA.COL_PROPIETARIO'},

        {Header: 'C.H.'},
      ] as const;
  }
  public getPartida(partida: string, separator: string): string {
    const structure = partida.split(separator);
    return structure.slice(-1).toString();
  }

  public crearColumnasPegadoEspecial() {
    return [
      this.mObjGenerico.getTranslationsSubject('GRIDS.PARTIDAS.COL_PARTIDA'), // obligatoria
      this.mObjGenerico.getTranslationsSubject('GRIDS.PARTIDAS.COL_PARTIDA_AUX'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.PARTIDAS.COL_METROS2'),
      // Conceptos
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_MARCA'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_RENGLON'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CODIGO'), // obligatoria
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CODIGO_AUX'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION_LARGA'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_UNIDAD'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CANTIDAD'), // obligatoria
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_COSTO_M1'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_PRECIO_M1'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_COSTO_M2'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_PRECIO_M2'),
      this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_TIPO_INSUMO')
    ];
  }
  // endregion

  // region Agregar errores al grid de DetallePegado
  public validarEdicionTipoInsumo(codigo, item: ClsPegado) {
    if (item.Column === this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_DESCRIPCION')) {
      const errorEdicion = this.validarTipoInsumo(codigo, item, this.mObjGenerico);
      if (!ClsUtil.esNulo(errorEdicion)) {
        this.dataDetallePegado.push(errorEdicion);
      }
    }
  }
  public validarTipoInsumoCatsMAEQMO(codigo: string, item: ClsPegado, grid: EnumNombresGrids) {
    if (item.Column === this.mObjGenerico.getTranslationsSubject('GRIDS.MATERIALES.COL_TIPO_INSUMO')) {
      const errorTipoInsumoIncorrecto = this.validarTipoInsumoMAEQMO(codigo, item, grid, this.mObjGenerico);
      if (!ClsUtil.esNulo(errorTipoInsumoIncorrecto)) {
        this.dataDetallePegado.push(errorTipoInsumoIncorrecto);
      }
    }
  }

  public  validarCampos(codigoInsumo: string, item: ClsPegado, grid: EnumNombresGrids) {
    switch (item.DataType) {
      case EnumTiposDatosPegado.String:
        if (!ClsUtil.esNulo(item.Value)) {
          if (grid === EnumNombresGrids.TipoInsumos) { // Valida edición tipos de insumos 1, 2 y 3
            this.validarEdicionTipoInsumo(codigoInsumo, item);
          }
          this.validarMaxLength(codigoInsumo, item);
        }
        break;
      case EnumTiposDatosPegado.Number:
        const colRenglon = this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_RENGLON');
        const colEsPorc = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_TIPO_%');
        if (item.Column === colRenglon || item.Column === colEsPorc) { // excepciones
          break;
        }
        const colTipoInsumo = this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_TIPO');
        if (item.Column === colTipoInsumo) { // validar Tipo Insumo
          if (grid === EnumNombresGrids.Materiales || grid === EnumNombresGrids.Maquinaria || grid === EnumNombresGrids.MO) { // Valida agregar insumos no correspondientes al catalogo
            this.validarTipoInsumoCatsMAEQMO(codigoInsumo, item, grid);
          }
          this.validarTipoInsumoToNumber(item.Value, item);
        } else { // validar cualquier otra columna tipo Number
          const num = Number(item.Value);
          if (isNaN(num)) {
            const local = ClsUtil.obtenerLenguaje();
            const formato = local === 'es' ? 'numérico' : 'numeric';
            const msj = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.FORMATO_INCORRECTO_PEGADO').replace('{0}', item.Column).replace('{1}', formato);
            const error = {Codigo: codigoInsumo, Columna: item.Column, Detalle: msj};
            this.dataDetallePegado.push(error);
          } else {
            this.validarMaxLength(codigoInsumo, item);
          }
        }
        break;
      case EnumTiposDatosPegado.Currency:
        const errorMoneda = this.validarFormatoMoneda(codigoInsumo, item.Column, item.Value);
        if (!ClsUtil.esNulo(errorMoneda)) {
          this.dataDetallePegado.push(errorMoneda);
        } else {
          this.validarMaxLength(codigoInsumo, item);
        }
        break;
      case EnumTiposDatosPegado.Quantity:
        const errorCantidad = this.validarFormatoCantidad(codigoInsumo, item.Column, item.Value);
        if (!ClsUtil.esNulo(errorCantidad)) {
          this.dataDetallePegado.push(errorCantidad);
        } else {
          this.validarMaxLength(codigoInsumo, item);
        }
        break;
      case EnumTiposDatosPegado.Boolean:
        break;
      case EnumTiposDatosPegado.Url:
        if (!ClsUtil.esNulo(item.Value)) {
          const errorURL = this.validarUrl(codigoInsumo, item.Value, item.Column);
          if (!ClsUtil.esNulo(errorURL)) {
            this.dataDetallePegado.push(errorURL);
          } else {
            this.validarMaxLength(codigoInsumo, item);
          }
        }
        break;
    }
  }

  public validarNulo(codigoInsumo: string, item: ClsPegado) {
    let errorNulo: any;
    if (ClsUtil.esNulo(item.Value)) {
      errorNulo = {Codigo: codigoInsumo, Columna: item.Column, Detalle: this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', item.Column)};
      this.dataDetallePegado.push(errorNulo);
    } else {
      // this.validarMaxLength(codigoInsumo, item);
    }
    return errorNulo;
  }

  public validarMaxLength(codigoInsumo: string, item: ClsPegado) {
    const error = this.validarLengthMaxDif(codigoInsumo, item.Column, item.Value, item.MaxValue);
    if (!ClsUtil.esNulo(error)) {
      this.dataDetallePegado.push(error);
    }
  }

  public validarTipoInsumoToNumber(codigoInsumo: string, item: ClsPegado) {
    if (!ClsUtil.esNulo(item.Value)) {
      const num = Number(item.Value);
      const errorInt = this.validarNumberInt(codigoInsumo, item, num);
      if (!ClsUtil.esNulo(errorInt)) {
        this.dataDetallePegado.push(errorInt);
      } else {
        const errorCero = this.validarTipoInsumoCero(num, item);
        if (!ClsUtil.esNulo(errorCero)) {
          this.dataDetallePegado.push(errorCero);
        } else {
          this.validarMaxLength(codigoInsumo, item);
        }
      }
    }
  }
  // endregion
  // region Validaciones
  /**
   * Válida la longitud máxima de la cadena
   * @param codigo - Código del catálogo
   * @param col - Columna a validar (field)
   * @param valor - Valor de la celda
   * @param maxLength - Longitud máxima
   */
  public validarLengthMaxDif(codigo: string, col: string, valor: string, maxLength: number): ClsColDetallePegado {
    try {
      let aux: any;
      const colDes: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_DESCRIPCION');
      const colRescateCh: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MAQUINARIA.COL_VALOR_RESCATE');
      const colTasaInteres1: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MAQUINARIA.COL_TASA_INTERES_M1');
      const colTasaInteres2: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MAQUINARIA.COL_TASA_INTERES_M2');
      const colPrima: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MAQUINARIA.COL_PRIMA_ANUAL_SEGUROS');
      const colFOpera: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MAQUINARIA.COL_FACTOR_OPERACION');
      if (valor.length > maxLength && (col !== colDes || col !== colRescateCh)) {
        aux = {Codigo: codigo, Columna: col, Detalle: this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAXIMO').replace('{0}', col).replace('{1}', maxLength.toString()).replace('{2}', codigo)};
      }

      // Diccionario de validaciones especiales
      const validacionesCH: Record<string, string> = {
        [colRescateCh]:   'MENSAJES.ALERT.CH_VALOR_RESCATE_MAYOR100',
        [colTasaInteres1]: 'MENSAJES.ALERT.CH_VALOR_INTERES_MAYOR100',
        [colTasaInteres2]: 'MENSAJES.ALERT.CH_VALOR_INTERES_MAYOR100',
        [colPrima]:        'MENSAJES.ALERT.CH_PORCENTAJE_SEGURO_MAYOR100',
        [colFOpera]:        'MENSAJES.ALERT.CH_FACTOR_OPER_MAYOR100',
      };

      if (validacionesCH[col] && Number(valor) > maxLength) {
        aux = {
          Codigo: codigo,
          Columna: col,
          Detalle: this.mObjGenerico.getTranslationsSubject(validacionesCH[col]),
        };
      }

      return aux;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarFormatoCantidad(codigo: string, col: string, cantidadStr: string): ClsColDetallePegado {
    try {
      let error: any;
      if (!ClsUtil.isvalidQuantityFormat(cantidadStr)) {
        const msj = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.FORMATO_INCORRECTO_CANTIDAD');
        error = {Codigo: codigo, Columna: col, Detalle: msj};
      }

      return error;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarFormatoMoneda(codigo: string, col: string, costoStr: string): ClsColDetallePegado {
    try {
      let error: any;
      if (!ClsUtil.validCurrencyFormat(costoStr)) {
        const msj = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.FORMATO_INCORRECTO_MONEDA');
        error = {Codigo: codigo, Columna: col, Detalle: msj};
      }

      return error;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarTipoInsumoCero(codigo: number, item: ClsPegado): ClsColDetallePegado {
    try {
      let aux: any;
      if (codigo <= 0) {
        aux = {Codigo: codigo, Columna: item.Column, Detalle: this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_TIPO_INSUMO_CERO').replace('{0}', codigo.toString())};
      }
      return  aux;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Válida que no se pueda editar los tipos de insumos 1, 2 y 3
   * @param codigo - TipoInsumo
   * @param item - Datos que se valida al pegar
   * @param objGenerico - Obj para la traducción de mensajes
   */
  public validarTipoInsumo(codigo: string, item: any, objGenerico: ClsObjGenerico): ClsColDetallePegado {
    try {
      let aux: any;
      if (codigo === '1' || codigo === '2' || codigo === '3') {
        aux = {Codigo: codigo, Columna: item.Col, Detalle: objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_EDICION_TIPO_INSUMO').replace('{0}', codigo)};
      }
      return aux;
    } catch (e) {
      throw new Error(e.message);
    }
  }
  /**
   * Válida que no se pueda editar los tipos de insumos 1, 2 y 3
   * @param codigo - TipoInsumo
   * @param item - Datos que se valida al pegar
   * @param grid - Nombre del grid
   * @param objGenerico - Obj para la traducción de mensajes
   */
  public validarTipoInsumoMAEQMO(codigo: string, item: ClsPegado, grid: EnumNombresGrids, objGenerico: ClsObjGenerico): ClsColDetallePegado {
    try {
      let aux: any;
      switch (grid) {
        case EnumNombresGrids.Materiales:
          if (item.Value !== '1') {
            aux = {Codigo: codigo, Columna: item.Column, Detalle: objGenerico.getTranslationsSubject('MENSAJES.ALERT.AGREGAR_TIPO_INSUMO_X').replace('{0}', item.Value).replace('{1}', objGenerico.getTranslationsSubject('MENSAJES.GRALS.MATERIALES'))};
          }
          break;
        case EnumNombresGrids.MO:
          if (item.Value !== '2') {
            aux = {Codigo: codigo, Columna: item.Column, Detalle: objGenerico.getTranslationsSubject('MENSAJES.ALERT.AGREGAR_TIPO_INSUMO_X').replace('{0}', item.Value).replace('{1}', 'Mano de obra')};
          }
          break;
        case EnumNombresGrids.Maquinaria:
          if (item.Value !== '3') {
            aux = {Codigo: codigo, Columna: item.Column, Detalle: objGenerico.getTranslationsSubject('MENSAJES.ALERT.AGREGAR_TIPO_INSUMO_X').replace('{0}', item.Value).replace('{1}', 'Maquinaria')};
          }
          break;
      }
      return aux;
    } catch (e) {
      throw new Error(e.message);
    }
  }
  /**
   * Válida que un número sea entero
   * @param codigo - Código del catálogo
   * @param item - item
   * @param num - número a validar
   */
  public validarNumberInt(codigo: string, item: ClsPegado, num: any): ClsColDetallePegado {
    try {
      let aux: any;
      if (!Number.isInteger(num) || isNaN(num)) {
        aux = {Codigo: codigo, Columna: item.Column, Detalle: this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_INTEGER').replace('{0}', item.Value)};
      }
      return aux;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarUrl(codigo: string, url: any, col: string): ClsColDetallePegado {
    try {
      let error: any;
      if (!this.gRegexUrl.test(url)) {
        error = {Codigo: codigo, Columna: col, Detalle: this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.URL_NO_VALIDO')};
      }
      return error;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarFormatoNumber(codigo: string, num: any, col: string, esCantidad: boolean): ClsColDetallePegado {
    try {
      let error: any;
      let msj = '';
      if (isNaN(num)) {
        if (esCantidad) {
          msj = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.FORMATO_INCORRECTO_CANTIDAD');
        } else {
          msj = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.FORMATO_INCORRECTO_MONEDA');
        }
        error = {Codigo: codigo, Columna: col, Detalle: msj};
      }
      return error;
    } catch (e) {
      throw new Error(e.message);
    }
  }
  // endregion

  public reemplazarDataPegado(datosPegado: any, rowExistente: any) {
    try {
      const colDesCom: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_DESCRIPCION_LARGA');
      const colDes: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_DESCRIPCION');
      const colTipo: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_TIPO_INSUMO');
      const colUni: string = this.mObjGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_UNIDAD');
      const colEsPorc: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_TIPO_%');
      // if (ClsUtil.esNulo(datosPegado[colDes]) && ClsUtil.esNulo(datosPegado[colDesCom])) {
      //   rowExistente.Descripcion = rowExistente.Descripcion;
      //   rowExistente.DescripcionLarga = rowExistente.DescripcionLarga;
      // } else
        if (!ClsUtil.esNulo(datosPegado[colDes]) && !ClsUtil.esNulo(datosPegado[colDesCom])) {
        rowExistente.Descripcion = datosPegado[colDes];
        rowExistente.DescripcionLarga = datosPegado[colDesCom];
      } else if (!ClsUtil.esNulo(datosPegado[colDes])) {
        rowExistente.Descripcion = datosPegado[colDes];
        rowExistente.DescripcionLarga = datosPegado[colDes];
      } else if (!ClsUtil.esNulo(datosPegado[colDesCom])) {
        rowExistente.Descripcion = datosPegado[colDesCom].substring(0, 40);
        rowExistente.DescripcionLarga = datosPegado[colDesCom];
      }
      rowExistente.Unidad = ClsUtil.esNulo(datosPegado[colUni]) ? rowExistente.Unidad : datosPegado[colUni].toUpperCase();
      rowExistente.TipoInsumo = ClsUtil.esNulo(datosPegado[colTipo]) ? rowExistente.TipoInsumo : Number(datosPegado[colTipo]);
      rowExistente.EsPorcentaje = ClsUtil.esNulo(datosPegado[colEsPorc]) ? rowExistente.EsPorcentaje : Number(datosPegado[colEsPorc]);
      return rowExistente;
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    }
  }
  // region Util
  /**
   *
   * @param data - Datos del pegado
   * @param grid - Nombre del grid
   */
  public mergeDescriptions(data: any[], grid: any) {
    const obj = this.setPrimarycolumn(grid);
    const colCod: string = obj.code;
    const colDesCom: string = obj.desc;
    const colDes: string = obj.des;
    return data.reduce((acc, item) => {
      if (ClsUtil.esNulo(item[colCod]) && (!ClsUtil.esNulo(item[colDesCom]) || !ClsUtil.esNulo(item[colDes]))) {
        const lastItem = acc.length > 0 ? acc[acc.length - 1] : undefined;
        if (!ClsUtil.esNulo(lastItem)) {
          if (!ClsUtil.esNulo(lastItem[colDes])) {
            lastItem[colDes] += ` ${item[colDes]}`;
          }
          if (!ClsUtil.esNulo(lastItem[colDesCom])) {
            lastItem[colDesCom] += ` ${item[colDesCom]}`;
          }
        }
      } else {
        acc.push({...item});
      }

      return acc;
    }, []);
  }

  public mergeDescriptionSpecial(data: any[]) {
    const colPart: string = this.mObjGenerico.getTranslationsSubject('GRIDS.PARTIDAS.COL_PARTIDA');
    const colCod: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CODIGO');
    const colDesCom: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION_LARGA');
    return data.reduce((acc, item) => {
      if (ClsUtil.esNulo(item[colPart]) && ClsUtil.esNulo(item[colCod]) && !ClsUtil.esNulo(item[colDesCom])) {
        const lastItem = acc.length > 0 ? acc[acc.length - 1] : undefined;
        if (!ClsUtil.esNulo(lastItem)) {
          if (!ClsUtil.esNulo(lastItem[colDesCom])) {
            lastItem[colDesCom] += ` ${item[colDesCom]}`;
          }
        }
      } else {
        acc.push({...item});
      }

      return acc;
    }, []);
  }

  public setPrimarycolumn(grid: any) {
    let obj: any;
    switch (grid) {
      case EnumNombresGrids.Conceptos:
      case EnumNombresGrids.Matrices:
      case EnumNombresGrids.ExpIns:
      case EnumNombresGrids.Materiales:
      case EnumNombresGrids.MO:
      case EnumNombresGrids.Maquinaria:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_CODIGO'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION_LARGA'),
          des: this.mObjGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION')};
        break;
      case EnumNombresGrids.Empresas:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_EMPRESA'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_RS')};
        break;
      case EnumNombresGrids.Ciudades:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.CIUDAD.COL_CIUDAD'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.CIUDAD.COL_DESCRIPCION')};
        break;
      case EnumNombresGrids.TiposLicitaciones:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_LICITACION.COL_TIPO'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_LICITACION.COL_DESCRIPCION')};
        break;
      case EnumNombresGrids.Vendedores:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_VENDEDOR'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_NOMBRE')};
        break;
      case EnumNombresGrids.Clientes:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_CLIENTE'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_NOMBRE')};
        break;
      case EnumNombresGrids.Proveedores:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_PROVEEDOR'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_RS')};
        break;
      case EnumNombresGrids.Responsables:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_RESPONSABLE'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_NOMBRE')};
        break;
      case EnumNombresGrids.Estados:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.ESTADO.COL_ESTADO'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.ESTADO.COL_NOMBRE')};
        break;
      case EnumNombresGrids.Familias:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.FAMILIA.COL_FAMILIA'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.FAMILIA.COL_DESCRIPCION')};
        break;
      case EnumNombresGrids.Unidades:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.UNIDAD.COL_UNIDAD'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.UNIDAD.COL_DESCRIPCION')};
        break;
      case EnumNombresGrids.TipoInsumos:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_TIPO'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_DESCRIPCION')};
        break;
      case EnumNombresGrids.Regiones:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.REGION.COL_REGION'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.REGION.COL_DESCRIPCION')};
        break;
      case EnumNombresGrids.Calendario:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_FECHA'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO.COL_DESCRIPCION')};
        break;
      case EnumNombresGrids.Fechas:
        obj = {code: this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIOS.COL_FECHA_NO_LABORABLE'),
          desc: this.mObjGenerico.getTranslationsSubject('GRIDS.FECHAS.COL_DESCRIPCION')};
        break;
    }
    return obj;
  }
  // end region
}
